import { AxiosCallPostWithErr2 } from './apicall'
import debounce from 'debounce-async'
import { LynxUtils } from '@/utils'
import FindKeyConstants from '@/utils/FindKeyConstants.js'
import ContactFilteringCategoryEnum from '@/utils/ContactFilteringCategoryEnum.js'

/**
 * Contact Lynx
 */

const debouncedAutoCompleteContacts = LynxUtils.DebounceWithTryCatch([], debounce(AxiosCallPostWithErr2, 700))
export default class ContactService {
  /**
   * Constructor.
   * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
   */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  async autocompleteContact (strSearch, typecontact, includeclosed) {
    const fr = {
      SearchKeys: {
        [FindKeyConstants.AUTOC_FILTER]: strSearch,
        [FindKeyConstants.FR_FIND_MAX_VAL]: 20,
        [FindKeyConstants.FR_CONTACT_TYPES]: ContactFilteringCategoryEnum.ALL + ',' + typecontact
      }
    }
    if (includeclosed && includeclosed === true) {
      fr.SearchKeys[FindKeyConstants.FR_CRIT_POS_SYNTH_STATE] = 'Open,Closed'
    }
    const res = await debouncedAutoCompleteContacts('lynxapi/candidate/findcandidates', fr)
    return res?.result
  }

  async findMatchingCandidates (filter) {
    const fr = {
      SearchKeys: {
        [FindKeyConstants.FR_FIND_MAX_VAL]: 100,
        [FindKeyConstants.FR_CANDIDATES_ONLY]: true,
        [FindKeyConstants.FR_MIXED_CAND_CUST]: true,
        [FindKeyConstants.FR_CONTACT_TYPES]: ContactFilteringCategoryEnum.ALL + ',' + ContactFilteringCategoryEnum.CAND
      }
    }
    if (filter.FirstNameLastName) {
      fr.SearchKeys[FindKeyConstants.FR_FIRST_NAME_LAST_NAME] = filter.FirstNameLastName
    }
    if (filter.Xp) {
      fr.SearchKeys[FindKeyConstants.FR_XP] = filter.Xp
    }
    if (filter.SelectedCandStates) {
      fr.SearchKeys[FindKeyConstants.FR_CAND_STATES] = LynxUtils.CreateIdListFromList(filter.SelectedCandStates)
    }
    if (filter.SelectedPositionTypes) {
      fr.SearchKeys[FindKeyConstants.FR_POSITION_TYPES] = LynxUtils.CreateIdListFromList(filter.SelectedPositionTypes)
    }
    if (filter.SelectedSkills) {
      fr.SearchKeys[FindKeyConstants.FR_SKILLS1] = LynxUtils.CreateIdListFromList(filter.SelectedSkills)
      fr.SearchKeys[FindKeyConstants.FR_COMBINE_SKILLS10] = filter.Allskills
    }
    if (filter.SelectedSales) {
      const contids = LynxUtils.CreateIdListFromObjectsWithProp(filter.SelectedSales, 'contactId')
      fr.SearchKeys[FindKeyConstants.FR_CANDSALESSUPERV] = contids
      fr.SearchKeys[FindKeyConstants.FR_POSREFCAREER] = contids
      fr.SearchKeys[FindKeyConstants.FR_COMBINE_INV_CUS_POS] = true
    }
    const res = await AxiosCallPostWithErr2('lynxapi/candidate/findcandidates', fr)
    if (res == null) {
      return null
    }
    return {result: res.result, count: res.count}
  }

  async findMatchingCustomers (filter) {
    const fr = {
      SearchKeys: {
        [FindKeyConstants.FR_FIND_MAX_VAL]: 100,
        [FindKeyConstants.FR_CUSTOMERS_ONLY]: true,
        [FindKeyConstants.FR_MIXED_CAND_CUST]: true,
        [FindKeyConstants.FR_CONTACT_TYPES]: ContactFilteringCategoryEnum.ALL + ',' + ContactFilteringCategoryEnum.CUST
      }
    }
    if (filter.FirstNameLastName) {
      fr.SearchKeys[FindKeyConstants.FR_FIRST_NAME_LAST_NAME] = filter.FirstNameLastName
    }
    if (filter.SelectedCustStates) {
      fr.SearchKeys[FindKeyConstants.FR_CUST_STATES] = LynxUtils.CreateIdListFromList(filter.SelectedCustStates)
    }
    if (filter.SelectedEntities) {
      fr.SearchKeys[FindKeyConstants.FR_ACCOUNTS] = LynxUtils.CreateIdListFromObjects(filter.SelectedEntities)
    }
    if (filter.SelectedSales) {
      const contids = LynxUtils.CreateIdListFromObjectsWithProp(filter.SelectedSales, 'contactId')
      fr.SearchKeys[FindKeyConstants.FR_CUSSALESSUPERV] = contids
      fr.SearchKeys[FindKeyConstants.FR_COMBINE_INV_CUS_POS] = true
    }
    const res = await AxiosCallPostWithErr2('lynxapi/customer/findcustomers', fr)
    if (res == null) {
      return null
    }
    return {result: res.result, count: res.count}
  }
}
